let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9qc0L")).then(() => parcelRequire('67pUS'));